import React from "react";

const Advertise = () => {
    return (
        <div className="container-fluid bg-dark py-2  d-md-flex">
        <div className="container">
            <div className="d-flex justify-content-between topbar">
                <div id="note" className="text-secondary d-xl-flex"><small>Note : We help you to Grow your Business</small></div>
                <div className="top-link">
                    <a href="" className="bg-light nav-fill btn btn-sm-square rounded-circle"><i className="fab fa-facebook-f text-primary"></i></a>
                    <a href="" className="bg-light nav-fill btn btn-sm-square rounded-circle"><i className="fab fa-twitter text-primary"></i></a>
                    <a href="" className="bg-light nav-fill btn btn-sm-square rounded-circle"><i className="fab fa-instagram text-primary"></i></a>
                    <a href="" className="bg-light nav-fill btn btn-sm-square rounded-circle me-0"><i className="fab fa-linkedin-in text-primary"></i></a>
                </div>
            </div>
        </div>
    </div>
    );
}
export default Advertise;